import Button from "components/atoms/Button";
import ReserveProductDesc from "components/molecules/ReserveProductDesc";
import React from "react";
import { joinClassnames } from "utils/map-modifier";
import "./index.scss";

interface BuyNowButtonProps {
  type: "buynow" | "outstock";
  variant?: "light" | "primary";
  disabled?: boolean;
  isItemProduct?: boolean;
  className?: string;
  modifier?: "white";
  hideIcon?: boolean;
  ctaText?: string;
  ctaDesc?: string;
  handleClick?: (e: any) => void;
}

const BuyNowButton: React.FC<BuyNowButtonProps> = ({
  type,
  variant,
  disabled,
  className,
  modifier,
  isItemProduct,
  hideIcon,
  ctaText,
  ctaDesc,
  handleClick,
}) => (
  <>
    {ctaDesc && <ReserveProductDesc content={ctaDesc} />}
    <Button
      variant={variant || "primary"}
      {...(!hideIcon ? { iconName: "cart-white" } : {})}
      className={joinClassnames("a-buy-now-button", className)}
      modifiers={
        isItemProduct ? ["rounded", "w-min-170"] : modifier ? [modifier] : []
      }
      {...(type === "outstock"
        ? {
            disabled: true,
          }
        : {
            disabled,
          })}
      onClick={handleClick}
    >
      {type === "outstock" ? "Tạm hết hàng" : ctaText || "Mua ngay"}
    </Button>
  </>
);

export default BuyNowButton;
